export type QuotaMood = 'safe' | 'warn' | 'limit';
export type QuotaPeriod = 'week' | 'month' | 'year' | 'lifetime';
export type QuotaUnit = 'video_count' | 'video_size';

export const getQuotaMood = (used: number, max: number, unit: QuotaUnit): QuotaMood => {
  if (unit === 'video_count' && used >= 0 && max >= 0) {
    if (max <= 10) {
      if (max - used <= 1) {
        return 'limit';
      }

      if (used / max >= 7 / 10) {
        return 'limit';
      }

      if (used / max >= 1 / 2) {
        return 'warn';
      }
    }

    if (max > 10) {
      if (used / max >= 9 / 10) {
        return 'limit';
      }

      if (used / max >= 2 / 3) {
        return 'warn';
      }
    }

    return 'safe';
  }

  if (unit === 'video_size' && used >= 0 && max >= 0) {
    if (used / max >= 9 / 10) {
      return 'limit';
    }

    if (used / max >= 2 / 3) {
      return 'warn';
    }
  }

  return 'safe';
};
